/**
 * Role helpers
 *
 * Keycloak realm roles arrive with inconsistent casing (`ADMIN`, `admin`,
 * `user`, `USER`) depending on the auth flow and where they are read from
 * (JWT claim vs. login response body). Every role check must therefore be
 * case-insensitive. These helpers are the single source of truth for that.
 */

/** True if `roles` contains `role`, compared case-insensitively. */
export const hasRole = (roles: string[] | undefined, role: string): boolean =>
  (roles ?? []).some((r) => r?.toUpperCase() === role.toUpperCase());

/** True if the user holds an admin-level realm role. */
export const isAdminRole = (roles?: string[]): boolean =>
  hasRole(roles, 'ADMIN') || hasRole(roles, 'SUPER_ADMIN');
